/**
 * @fileoverview Icon Registry - Auto-registers core, blueprint, and POI icon sets
 * @module icons
 * @version 1.0.0
 *
 * @description
 * Imports and registers all icon sets with the ctl-icon component:
 * - Core icons (general UI)
 * - Blueprint / floor plan icons (map editor)
 * - Point-of-Interest icons (facility directory & venue maps)
 *
 * Import this file to make all icons available throughout your application.
 *
 * @example
 * // Import to register all icons
 * import '@cliftontechlabs/ui-kit/icons';
 *
 * // Then use any icon by name
 * <ctl-icon name="check"></ctl-icon>
 * <ctl-icon name="floor-plan"></ctl-icon>
 * <ctl-icon name="restroom"></ctl-icon>
 * <ctl-icon name="parking"></ctl-icon>
 */

import { registerIcons } from '../components/ctl/foundation/ctl-icon.js';
import { CORE_ICONS } from './core-icons.js';
import { BLUEPRINT_ICONS } from './blueprint-icons.js';
import { POI_ICONS } from './poi-icons.js';

// Auto-register core icons on import
registerIcons(CORE_ICONS);

// Auto-register blueprint/floor plan icons on import
registerIcons(BLUEPRINT_ICONS);

// Auto-register point-of-interest icons on import
registerIcons(POI_ICONS);

// Export for programmatic access if needed
export { CORE_ICONS } from './core-icons.js';
export { BLUEPRINT_ICONS } from './blueprint-icons.js';
export { POI_ICONS } from './poi-icons.js';
export { registerIcon, registerIcons } from '../components/ctl/foundation/ctl-icon.js';
